/** Referral status constants */
export enum REFERRAL_STATUS {
	my_requests = 'My Requests',
	referral_ready = 'Referral Ready',
	pending_appointments = 'Pending Appointments',
	confirmed_appointments = 'Confirmed Appointments',
}

/** Referral components constants */
export enum REFERRAL_COMPONENTS {
	MY_REQUESTS = 'my_requests',
	REFERRAL_READY = 'referral_ready',
	PENDING_APPOINTMENTS = 'pending_appointments',
	CONFIRMED_APPOINTMENTS = 'confirmed_appointments',
}
